export default "__VITE_ASSET__0djb0gbJ__"